const de = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title':
    'Ermittlungsquellenname',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'Nutzer-ID',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Service Now-URL',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'Passwort',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'Ungültige URL',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'Ermittlungshäufigkeit',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'Aufforderung an die Nutzer, Fragen zur wissensbasierten Authentifizierung (Knowledge-Based Authentication, KBA) zu beantworten.',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'Entdecken Sie Ihre Anwendungen und Workloads über eine dieser beliebten Erkennungsquellen. Sie profitieren von Vorteilen wie vorausgefüllten Details, priorisierten Empfehlungen und einem vollständigen Überblick über den Onboarding-Status.',
  'INTEGRATIONS.DISCOVERY.BACK': 'Zurück',
  'INTEGRATIONS.DISCOVERY.TITLE': 'Ermittlung einrichten',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'Bald verfügbar...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'Weitere Informationen',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'Geben Sie Ihre Anmeldedaten für die Anwendung ein, um eine Verbindung herzustellen. Sobald die Verbindung erfolgreich hergestellt wurde, können Sie die Daten importieren.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING':
    'Beim Laden der Seite ist ein Fehler aufgetreten.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'Aktualisieren Sie oder schauen Sie später noch einmal nach Falls das Problem weiterhin besteht, wenden Sie sich an den Administrator.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'Neu laden',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'Verbindungseinstellungen',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI-Klassen***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title':
    'Attributzuordnung',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'Verbindungsdetails',
  'INTEGRATIONS.BUTTON.SAVE': 'Speichern',
  'INTEGRATIONS.DISCOVERY.SELECT': 'Auswählen',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'Neue Verbindung erstellen',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'Diese Verbindung verwenden',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow gespeichert!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'Ihre Verbindung mit der Erkennungsquelle ServiceNow wurde erfolgreich getestet und gespeichert. Importieren Sie Daten, um die Einrichtung der Erkennung abzuschließen. Sie können überspringen...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'Importieren von Assets',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'Vorläufig überspringen',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'Sobald der Import beginnt, kann er nicht mehr abgebrochen werden.',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'Anleitung aktivieren',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'Vorhandene Verbindung auswählen',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'Verbindungsname',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'Wir haben {total, plural, one {eine} other {#}} vorhandene Verbindungskonfiguration ermittelt:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'Import starten',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'Daten aus Excel-Datei importieren. Bitte warten...',
  'INTEGRATIONS.TRY.AGAIN': 'Erneut versuchen',
  'INTEGRATIONS.CLOSE': 'Schließen',
  'INTEGRATIONS.ERROR.CONNECTION':
    'Verbindungsfehler. Bitte versuchen Sie es erneut.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'Sie können die Seite während des Wartens beenden. Wir benachrichtigen Sie, wenn der Prozess abgeschlossen ist.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'Ermittlungsquelle importieren',
  'INTEGRATIONS.FILEUPLOAD.HEADING':
    'Importieren Sie Ihre Ermittlungsquelle aus einer Datei',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'Beispieldatei herunterladen',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'Ermittlungsquellenname',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'Dateinamen eingeben',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'Geben Sie einen gültigen Namen ein. Nur Buchstaben, Ziffern und ausgewählte Symbole sind zulässig.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'Wird hochgeladen...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'Fortfahren',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'Hier sind die ersten 10 Datensätze aus der hochgeladenen XLSX-Datei.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'Erforderlicher Header fehlt',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'Spaltenfehler erkannt',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'Beheben Sie die Probleme, bevor Sie mit dem Datenimport fortfahren.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'Vom Import ausschließen',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE':
    'Anwendungsonboarding – Bestätigung',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'Anwendungstyp wurde identifiziert. Bitte bestätigen Sie, dass dies der richtige Anwendungstyp ist, für den Sie onboarden.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'Der Anwendungstyp für das Onboarding ist {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'Nein, aus einer Anwendungsliste auswählen',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'Ja, ich führe Onboarding durch',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'Integrationen',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'App-Integration hinzufügen',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'Keine Ergebnisse gefunden für',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'Keine',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': 'Integrationen gefunden.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN':
    'Keine versteckten Integrationen verfügbar.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'Ermittelte Anwendungen',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'Inhaber:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'Letzte Ermittlung am',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'Verbindung fehlgeschlagen',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'Nutzer haben Zugriff',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'Ermittlungsquelle',
  'INTEGRATIONS.BUTTON.ENABLE': 'Aktivieren',
  'INTEGRATIONS.BUTTON.DISABLE': 'Deaktivieren',
  'INTEGRATIONS.ENABLING': 'Wird aktiviert',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'Ermittlung',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'Erneutes Hochladen',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'Onboarden',
  'INTEGRATIONS.DASHBOARD.HIDE': 'Ausblenden',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'Einblenden',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL':
    'Registerkarten für Ermittlungskonfiguration',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'Ungespeicherte Änderungen verwerfen?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'Ungespeicherte Änderungen vorhanden. Die Änderungen gehen verloren, wenn Sie fortfahren.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'Änderungen verwerfen',
  'INTEGRATIONS.BUTTON.CANCEL': 'Abbrechen',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'Fehler beim Speichern',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'Zurück zur vorherigen Seite',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'Anwendungssymbol',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'Manuell ausführen',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE':
    'Deaktivieren fehlgeschlagen',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE':
    'Aktivieren fehlgeschlagen',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'Erfolgreich deaktiviert.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'Erfolgreich aktiviert.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'Ein weiterer Importvorgang wird ausgeführt.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'Assets werden derzeit von einem anderen Prozess importiert. Bitte später erneut versuchen.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED':
    'Importieren fehlgeschlagen',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS':
    'Assets werden aus ServiceNow importiert',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'Sie können die Seite während des Wartens beenden. Wir benachrichtigen Sie, wenn der Prozess abgeschlossen ist.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'Neue Zeile für Attributzuordnung hinzufügen',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'Attribut hinzufügen',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(Leer)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'Diese Zuordnung löschen',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow-Feld',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt-Feld',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'Nach ServiceNow-Attribut suchen',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT':
    'Nach Saviynt-Attribut suchen',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(Nutzerdefiniert)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'Speichern fehlgeschlagen',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'Zeitplankonfiguration',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': 'Um {timeLabel} UTC',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'Wiederholen am',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'Wiederholen an Tagen',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'Wiederholen alle',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'Intervall eingeben',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'Wiederholungsintervall in Anzahl der Tage, Wochen oder Monate eingeben',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'Tag',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'Woche(n)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'Monat',
  'INTEGRATIONS.DAYS.SUN': 'So',
  'INTEGRATIONS.DAYS.MON': 'Mo',
  'INTEGRATIONS.DAYS.TUE': 'Di',
  'INTEGRATIONS.DAYS.WED': 'Mi',
  'INTEGRATIONS.DAYS.THU': 'Do',
  'INTEGRATIONS.DAYS.FRI': 'Fr',
  'INTEGRATIONS.DAYS.SAT': 'Sa',
  'INTEGRATIONS.BUTTON.DISABLING': 'Wird deaktiviert',
  'INTEGRATIONS.BUTTON.SAVED': 'Gespeichert',
  'INTEGRATIONS.BUTTON.SAVING': 'Wird gespeichert',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE':
    'Möchten Sie wirklich deaktivieren? ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'Wenn Sie die Erkennungsquelle deaktivieren, wird der Asset-Import gestoppt und Sie können die Quelle nicht mehr konfigurieren.',
  'INTEGRATIONS.DISCOVERY.HERE': 'hier',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'Ihre Erkennungsquelle wurde erfolgreich erstellt, aber die Verbindung zu ServiceNow ist fehlgeschlagen. Um mit dem Import von Assets zu beginnen, aktualisieren Sie bitte die Verbindungsdetails auf der Konfigurationsseite der Ermittlungsquelle ',
};

export default de;
